<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" :width="dialogWidth" top="3vh" @close="close">
    <!-- 所属用户 -->
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item label="包裹图片" prop="code">
        <el-image v-for="(img, index) in ImagesrcList" style="width: 60px; height: 60px; margin-right: 5px" :src="img"
          :preview-src-list="getImgList(index)" @click="handleClickItem"></el-image>
      </el-form-item>

      <!-- 包裹单号 -->
      <el-form-item label="包裹单号" prop="code">
        <el-input v-model.trim="form.code" :readonly="true"></el-input>
      </el-form-item>
      <!-- 运单号 -->
      <el-form-item label="运单编号" prop="express_code">
        <el-input v-model.trim="form.express_code" :readonly="true"></el-input>
      </el-form-item>

      <!-- 预报发货方式 -->
      <el-form-item label="预报发货方式" prop="send_way">
        <span v-if="form.send_way == 0">-</span>
        <span v-if="form.send_way == 1">直接发货</span>
        <span v-if="form.send_way == 2">拆包发货</span>
        <span v-if="form.send_way == 3">合并发货</span>
      </el-form-item>

      <el-form-item label="配送方式" prop="pulling_type">
        <span v-if="form.pulling_type == 1">圆通快递</span>
        <span v-else-if="form.pulling_type == 2">京东快递</span>
        <span v-else-if="form.pulling_type == 3">顺丰快递</span>
        <span v-else="form.pulling_type == 3">-</span>
      </el-form-item>

      <!-- 预报商品信息 -->
      <el-form-item label="预报商品信息">
        <div v-for="(item, index) in listInfo" :key="index" class="xinxi">
          名称: {{ item.name }} &nbsp;&nbsp; 数量:{{ item.num }} &nbsp;&nbsp;
          价格:{{ item.price }}
        </div>
      </el-form-item>

      <!-- 预报备注 -->
      <el-form-item label="预报备注" prop="remark">
        <el-input v-model.trim="form.remark" :readonly="true"></el-input>
      </el-form-item>

      <!-- 仓储费用 -->
      <el-form-item label="仓储费用" prop="storage_price">
        <el-input v-model.trim="form.storage_price" :readonly="true"></el-input>
      </el-form-item>

      <!-- 重量 -->
      <el-form-item label="订单重量" prop="weight">
        <el-input v-model.trim="form.weight" :readonly="true"></el-input>
      </el-form-item>

      <!-- 价格 -->
      <el-form-item label="订单价格" prop="price">
        <el-input v-model.trim="form.price" :readonly="true"></el-input>
      </el-form-item>

      <!-- 申报价格 -->
      <el-form-item label="申报价格" prop="amount">
        <el-input v-model.trim="form.amount" :readonly="true"></el-input>
      </el-form-item>

      <!-- 完善备注 -->
      <el-form-item label="完善备注" prop="remark2">
        <el-input v-model.trim="form.remark2" :readonly="true"></el-input>
      </el-form-item>

      <!-- 用户名 -->
      <el-form-item label="用户名称" prop="name">
        <el-input v-model.trim="form.name" :readonly="true"></el-input>
      </el-form-item>
      <!-- 身份证号 -->
      <el-form-item label="身份证号" prop="idcode">
        <el-input v-model.trim="form.idcode" :readonly="true"></el-input>
      </el-form-item>
      <!-- 手机号 -->
      <el-form-item label="手机号码" prop="phone">
        <el-input v-model.trim="form.phone" :readonly="true"></el-input>
      </el-form-item>

      <!-- 详细地址 -->
      <el-form-item label="详细地址" prop="dizhi">
        <el-input v-model.trim="form.dizhi" :readonly="true"></el-input>
      </el-form-item>

      <!-- 开箱方式 -->
      <el-form-item label="开箱方式" prop="shipping_type_name">
        <el-select v-model="form.shipping_type" placeholder="请选择"
          :disabled="form.shipping_type == 3 || form.shipping_type == 4" style="width: 100%;">
          <el-option v-for="items in shippingList" :key="items.value" :label="items.label" :value="items.value"
            :disabled="items.disabled"></el-option>
        </el-select>
      </el-form-item>

      <!-- 增值服务信息 -->
      <el-form-item label="增值服务信息">
        <el-select v-model="service_list" multiple placeholder="请选择" style="width: 100%;">
          <el-option v-for="item in options" :key="item.id" :label="`${item.name} （${item.price ? item.price : '-'}）`"
            :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <!-- /////////////////////////////- -->
    <div style="text-align: center; margin-bottom: 18px; font-weight: bold">
      物品明细
    </div>
    <el-form ref="form" :model="form" label-width="100px">
      <div v-for="(item, index) in list" :key="index">
        <el-form-item label="商品名">
          <el-select v-model="item.b_type_id" filterable remote reserve-keyword placeholder="请输入关键词搜索"
            :remote-method="(query) => remoteMethod(query, index)" :loading="item.searchLoading"
            @change="handleChange($event, index)">
            <el-option v-for="items in item.filteredGoodsList" :key="items.id" :label="String(items.goods_name || '')"
              :value="items.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数量">
          <el-input v-model.trim="item.num" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="税金">
          <el-input v-model.trim="item.tax" style="width: 200px" @input="
            (e) => {
              item.tax = $geShi(e)
            }
          "></el-input>
        </el-form-item>
        <el-form-item label="序列号">
          <el-input v-model.trim="item.code" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button v-if="show" icon="el-icon-delete" type="danger" size="mini" @click="delItem(index)">
            删除
          </el-button>
        </el-form-item>
      </div>
      <el-form-item label="总税金">
        <span>{{ alltax() }}</span>
      </el-form-item>
    </el-form>
    <el-button icon="el-icon-plus" type="primary" size="mini" style="margin-top: 18px; margin-left: 100px"
      @click="addItem">
      添加
    </el-button>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save()">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  orderDetail,
  getBrandList,
  getBrandTypesList,
  orderBrandUpdate,
  serviceIndex,
  brand_filing
} from '@/api/xgcApi'

export default {
  name: 'UserManagementEdit',
  computed: {
    dialogWidth() {
      return window.innerWidth < 768 ? '99vw' : '600px'
    }
  },
  data() {
    return {
      id: '',
      ImagesrcList: [],
      goodsList: [], // 所有商品列表（包含100条 + 补充的商品）
      shippingList: [
        { value: 1, label: '原箱', disabled: false },
        { value: 2, label: '开箱', disabled: false },
        { value: 3, label: '分箱', disabled: true },
        { value: 4, label: '合箱', disabled: true },
        { value: 5, label: '暂存', disabled: true },
        { value: 6, label: '换箱', disabled: true },
        { value: 7, label: '合箱后分箱', disabled: true },
      ],
      dialogFormVisible: false,
      form: {},
      title: '订单详情',
      listInfo: [],
      service: [],
      brandList: [],
      value: 18,
      type: '',
      brandTypesList: [],
      list: [],
      show: false,
      options: [],
      service_list: [],
      searchTimer: null, // 防抖定时器
 
    }
  },
  created() { },
  methods: {
    // 弹窗初始化方法 // 获取详情数据
    async showEdit(row) {
      this.dialogFormVisible = true
      this.id = row.id
      // 1. 先请求100条商品数据
      await this.getGoodsList()

      // 2. 获取订单详情
      const { data } = await orderDetail({ id: row.id })
      this.form = data
      this.list = data.brand || []
      this.listInfo = data.item_info || []
      this.service = data.service || []
      this.ImagesrcList = data.all_pic || []
      // 初始化每行的 filteredGoodsList 和 searchLoading
      this.list.forEach((item) => {
        item.filteredGoodsList = [...this.goodsList]
        item.searchLoading = false
      })

      if (data.service && data.service.length > 0) {
        var arr = []
        data.service.forEach((item) => {
          arr.push(item.sid)
        })
        this.service_list = arr
        serviceIndex({}).then((res) => {
          this.options = res.data || []
        })
      } else {
        serviceIndex({}).then((res) => {
          this.options = res.data || []
        })
      }
      console.log(this.service_list, '65456')

      if (data.province_name == null) {
        this.form.dizhi = ''
      } else {
        this.form.dizhi =
          data.province_name + data.city_name + data.area_name + data.address
      }

      // 3. 检查并补充缺失的商品（用brand_type_name搜索）
      await this.checkAndAddMissingGoodsByName()
      // 4. 初始化 list 中的品牌类型信息
      if (data.brand) {
        data.brand.forEach((item, index) => {
          this.list[index].brandTypesList = [
            {
              brand_id: item.brand_id,
              code: item.code,
              id: item.b_type_id,
              name: item.brand_type_name,
            },
          ]
        })
      }

      this.show1()
    },

    // 实时搜索方法
    //     async remoteMethod(query, index) {
    //       console.log(query,index,'999999')
    //       // 如果输入为空，显示所有商品
    //       if (query === '') {
    //         this.list[index].filteredGoodsList = [...this.goodsList]
    //         this.$forceUpdate() // 强制更新视图
    //         return
    //       }

    //       // 显示加载状态
    //       this.list[index].searchLoading = true

    //       // 防抖处理
    //       if (this.searchTimer) {
    //         clearTimeout(this.searchTimer)
    //       }

    //       this.searchTimer = setTimeout(async () => {
    //         try {
    //           // 前端过滤
    //           const filtered = this.goodsList.filter(item =>
    //             item.goods_name && item.goods_name.toLowerCase().includes(query.toLowerCase())
    //           )
    //           // 使用 Vue.set 或重新赋值数组确保响应式
    //           this.$set(this.list[index], 'filteredGoodsList', filtered)

    //           // 或者使用 this.$forceUpdate() 强制更新
    //           // this.$forceUpdate()
    // console.log(filtered.length,'filtered.length')
    //           // 如果前端过滤后没有结果，调用后端接口搜索
    //           if (filtered.length === 0) {
    //             const result = await this.searchGoodsByName(query)
    //             if (result && result.length > 0) {
    //               // 将新搜索到的商品添加到 goodsList（去重）
    //               result.forEach(newItem => {
    //                 const exists = this.goodsList.some(g => g.id === newItem.id)
    //                 if (!exists) {
    //                   this.goodsList.push(newItem)
    //                 }
    //               })

    //               // 更新当前行的过滤列表
    //               this.$set(this.list[index], 'filteredGoodsList', result)
    //             }
    //           }

    //           this.list[index].searchLoading = false
    //           // 强制更新视图
    //           this.$forceUpdate()
    //         } catch (error) {
    //           console.log('搜索失败:', error)
    //           this.$set(this.list[index], 'filteredGoodsList', [...this.goodsList])
    //           this.list[index].searchLoading = false
    //           this.$forceUpdate()
    //         }
    //       }, 300) // 300ms 防抖延迟
    //     },
    // 实时搜索方法
    // async remoteMethod(query, index) {
    //   console.log(query, index, '999999')
    //   // 如果输入为空，显示所有商品
    //   if (query === '') {
    //     this.list[index].filteredGoodsList = [...this.goodsList]
    //     this.$forceUpdate()
    //     return
    //   }

    //   // 显示加载状态
    //   this.list[index].searchLoading = true

    //   // 防抖处理
    //   if (this.searchTimer) {
    //     clearTimeout(this.searchTimer)
    //   }

    //   this.searchTimer = setTimeout(async () => {
    //     try {
    //       // 前端过滤 - 添加安全处理
    //       const filtered = this.goodsList.filter(item => {
    //         // 确保 goods_name 存在且是字符串
    //         const goodsName = item.goods_name || item.name || '';
    //         // 确保是字符串类型
    //         const nameStr = String(goodsName);
    //         return nameStr.toLowerCase().includes(query.toLowerCase());
    //       });

    //       // 使用 Vue.set 或重新赋值数组确保响应式
    //       this.$set(this.list[index], 'filteredGoodsList', filtered)

    //       console.log(filtered.length, 'filtered.length')

    //       // 如果前端过滤后没有结果，调用后端接口搜索
    //       if (filtered.length === 0) {
    //         const result = await this.searchGoodsByName(query)
    //         if (result && result.length > 0) {
    //           // 将新搜索到的商品添加到 goodsList（去重）
    //           result.forEach(newItem => {
    //             const exists = this.goodsList.some(g => g.id === newItem.id)
    //             if (!exists) {
    //               this.goodsList.push(newItem)
    //             }
    //           })

    //           // 更新当前行的过滤列表
    //           this.$set(this.list[index], 'filteredGoodsList', result)
    //         }
    //       }

    //       this.list[index].searchLoading = false
    //       this.$forceUpdate()
    //     } catch (error) {
    //       console.log('搜索失败:', error)
    //       this.$set(this.list[index], 'filteredGoodsList', [...this.goodsList])
    //       this.list[index].searchLoading = false
    //       this.$forceUpdate()
    //     }
    //   }, 300)
    // },
    // 实时搜索方法 - 直接调用后端接口
    async remoteMethod(query, index) {
      // 如果输入为空，显示所有商品
      if (!query || query.trim() === '') {
        // 如果输入为空，显示全部商品（使用已加载的列表）
        this.$set(this.list[index], 'filteredGoodsList', [...this.goodsList]);
        this.$forceUpdate();
        return;
      }

      // 显示加载状态
      this.list[index].searchLoading = true;

      // 防抖处理
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }

      this.searchTimer = setTimeout(async () => {
        try {
          // 直接调用后端接口搜索
          const result = await this.searchGoodsByName(query);

          if (result && result.length > 0) {
            // 规范化数据
            const normalizedResult = result.map(item => ({
              ...item,
              goods_name: item.goods_name || item.name || `商品${item.id}`,
            }));

            // 将搜索结果添加到 goodsList（去重）
            normalizedResult.forEach(newItem => {
              const exists = this.goodsList.some(g => g.id === newItem.id);
              if (!exists) {
                this.goodsList.push(newItem);
              }
              console.log(this.goodsList, 'goodsList')
            });

            // 更新当前行的过滤列表
            this.$set(this.list[index], 'filteredGoodsList', normalizedResult);
          } else {
            // 没有搜索结果，显示空列表
            this.$set(this.list[index], 'filteredGoodsList', []);
          }

          this.list[index].searchLoading = false;
          this.$forceUpdate();
        } catch (error) {
          console.error('搜索失败:', error);
          // 搜索失败时显示所有商品
          this.$set(this.list[index], 'filteredGoodsList', [...this.goodsList]);
          this.list[index].searchLoading = false;
          this.$forceUpdate();
        }
      }, 300); // 300ms 防抖延迟
    },

    // 按名称搜索商品（修改为模糊搜索）
    async searchGoodsByName(name) {
      if (!name || name.trim() === '') return null;
      try {
        const res = await brand_filing({
          page: 1,
          limit: 20, // 增加返回数量
          keyword: name.trim() // 直接传递关键词进行模糊搜索
        });
        if (res.data && res.data.list && res.data.list.length > 0) {
          return res.data.list;
        }
        return null;
      } catch (e) {
        console.error('搜索接口调用失败:', e);
        return null;
      }
    },
    // 检查并补充缺失的商品（用名称搜索）
    async checkAndAddMissingGoodsByName() {
      // 遍历 list 中的每个商品
      for (const item of this.list) {
        // 如果 b_type_id 存在
        if (item.b_type_id) {
          // 检查是否已经在 goodsList 中
          const exists = this.goodsList.some(g => g.id === item.b_type_id)

          // 如果不存在，且有品牌类型名称，则用名称搜索
          if (!exists && item.brand_type_name) {
            const result = await this.searchGoodsByName(item.brand_type_name)
            if (result && result.length > 0) {
              // 搜索到了，添加到 goodsList
              const newItem = result[0]
              this.goodsList.push(newItem)
              // 同时更新所有行的 filteredGoodsList
              this.list.forEach(row => {
                if (row.filteredGoodsList) {
                  row.filteredGoodsList.push(newItem)
                }
              })
            } else {
              // 如果搜索不到，构造一个临时对象，保证下拉框能显示
              const tempGoods = {
                id: item.b_type_id,
                goods_name: item.brand_type_name,
              }
              this.goodsList.push(tempGoods)
              this.list.forEach(row => {
                if (row.filteredGoodsList) {
                  row.filteredGoodsList.push(tempGoods)
                }
              })
            }
          }
        }
      }
    },

    // 按名称搜索商品
    async searchGoodsByName(name) {

      if (!name) return null
      try {
        const res = await brand_filing({
          page: 1,
          limit: 10,
          keyword: name
        })
        if (res.data && res.data.list && res.data.list.length > 0) {
          return res.data.list
        }
        return null
      } catch (e) {
        return null
      }
    },

    // 请求商品数据（获取100条）
    async getGoodsList() {
      try {
        const res = await brand_filing({ page: 1, limit: 10 })
        this.goodsList = res.data && res.data.list ? res.data.list : []
      } catch (e) {
        this.goodsList = []
      }
    },

    alltax() {
      var shui = 0
      this.list.forEach((item, index) => {
        shui += Number(item.tax) * Number(item.num)
      })
      return shui.toFixed(2)
    },

    // 循环展示图片
    getImgList(index) {
      let arr = []
      let i = 0
      for (i; i < this.ImagesrcList.length; i++) {
        arr.push(this.ImagesrcList[i + index])
        if (i + index >= this.ImagesrcList.length - 1) {
          index = 0 - (i + 1)
        }
      }
      return arr
    },

    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },

    // 商品 处理选中值变化
    handleChange(value, index) {
      this.goodsList.forEach((item) => {
        if (value == item.id) {
          this.list[index].brand_type_name = item.goods_name || item.name
          this.list[index].tax = item.tax
          this.list[index].code = item.code
        }
      })
    },

    // 判断是否显示删除按钮
    show1() {
      if (this.list.length > 0) {
        this.show = true
      } else {
        this.show = false
      }
    },

    // 添加品牌列表
    addItem() {
      var data = {
        brand_id: '',
        b_type_id: '',
        brand_name: '',
        brand_type_name: '',
        num: '',
        code: '',
        tax: '',
        searchLoading: false,
        filteredGoodsList: [...this.goodsList],
      }
      this.list.push(data)
      this.show1()
    },

    // 删除列表
    delItem(index) {
      this.list.splice(index, 1)
      this.show1()
    },

    // 点击关闭弹窗
    close() {
      this.$refs['form'].resetFields()
      this.id = '',
        this.ImagesrcList = [],
        this.goodsList = [], // 所有商品列表（包含100条 + 补充的商品）
        this.form = {},
        this.listInfo = [],
        this.service = [],
        this.brandList = [],
        this.value = 18,
        this.type = '',
        this.brandTypesList = [],
        this.list = [],
        this.show = false,
        this.options = [],
        this.service_list = [],
        this.searchTimer = null, // 防抖定时器
        this.form = this.$options.data().form
      this.dialogFormVisible = false
      // 清除定时器
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
        this.searchTimer = null
      }
    },

    // 点击提交更改
    async save() {
      var date = {
        order_id: this.form.id,
        shipping_type: this.form.shipping_type,
        brand_list: this.list,
        service_list: this.service_list.join(',') || 0,
      }
      orderBrandUpdate(date).then(({ data, msg }) => {
        this.brandList = data
        this.$baseMessage(msg, 'success')
        this.$emit('fetch-data', true)
        this.close()
      })
    },
  },
}
</script>

<style scoped>
:deep .el-input--small .el-input__inner {
  width: 100%;
}

.black {
  font-weight: bold;
  color: #000000;
}

.red {
  color: #ff0000;
}

.xinxi {
  border: 1px solid #dcdfe6;
  padding-left: 15px;
  box-sizing: border-box;
  margin-bottom: 5px;
}

:deep .el-dialog__body {
  height: 70vh;
  overflow: hidden;
  overflow-y: scroll;
}
</style>